import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TicketModalStateService {
    private _isModalOpen$ = new BehaviorSubject<boolean>(false);
    public isModalOpen$ = this._isModalOpen$.asObservable();

    setModalOpen(isOpen: boolean): void {
        this._isModalOpen$.next(isOpen);
    }

    isModalOpen(): boolean {
        return this._isModalOpen$.value;
    }
}
